webpackJsonp([26],{

/***/ "isjR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/video-slider_986390f62bb608d1dec6acf0c3fd8ebd.html";

/***/ }),

/***/ "zMz2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lazy_modules_1 = __webpack_require__("bUzP");
var VideoSlider = (function () {
    VideoSlider.$inject = ["$element", "$q"];
    function VideoSlider($element, $q) {
        this.$element = $element;
        this.$q = $q;
        this.flicktyPromise = !options.handHeld ?
            $q(function (resolve) { return loadScripts([lazy_modules_1.flickityLib], resolve); }) :
            $q.reject(null);
    }
    VideoSlider.prototype.$postLink = function () {
        var _this = this;
        this.flicktyPromise.then(function () {
            var Flickity = window.Flickity;
            _this.flickity = new Flickity(_this.$element[0].firstChild, {
                cellSelector: 'video-slider .video-item',
                prevNextButtons: true,
                wrapAround: true,
                draggable: false,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false,
                pageDots: false
            });
            _this.hideButtons();
        });
    };
    VideoSlider.prototype.hideButtons = function () {
        if (this.flickity.slideableWidth <= this.flickity.slider.offsetWidth + 60) {
            this.flickity.deactivatePrevNextButtons();
        }
    };
    return VideoSlider;
}());
exports.VideoSlider = VideoSlider;
angular.module('animatronApp.videoSlider', []).component('videoSlider', {
    bindings: {
        videos: '<',
        height: '<'
    },
    controller: VideoSlider,
    templateUrl: __webpack_require__("isjR")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/26-82c0e6a2dceb23823569.min.js